import * as yup from 'yup'
import { IntlShape } from 'react-intl'
import { MagentoCustomizableOptionInterface } from 'lib/types'

export const schema = {
  sender: '',
  recipient: '',
  message: ''
}

export const validation = (deps: { options: MagentoCustomizableOptionInterface[], intl: IntlShape }) => {
  const { options, intl } = deps
  const requiredOptions = options.filter(opt => opt.required).map(getOptionName)
  const shape: Record<string, any> = {}

  requiredOptions.forEach(key => {
    shape[key] = yup.string().transform(getStringParsedValue).required(intl.formatMessage({ id: 'validation.required' }))
  })

  return (
    yup
      .object()
      .shape(shape)
  )
}

export const getOptionName = (option: MagentoCustomizableOptionInterface): string => {
  return `option-${option.option_id}`
}

export const getOptionId = (optionName: string): number => {
  return parseInt(optionName.replace('option-', ''))
}

export const getStringParsedValue = (originalValue: string | number | Array<number | string>) => {
  return Array.isArray(originalValue) ? originalValue.join(',') : originalValue.toString()
}
